export const getPrefix = () => window.location.pathname.split('/')[1] || 'd';